<template>
  <div>
    <page-navigate></page-navigate>
    <div class="orderflowHeader">
      <div class="orderflowHeaderMain">
        <h1 class="super_large-72_bold md-title-32_bold">订单流工具</h1>
        <div class="orderflowHeaderDesc subtitle-20_regular md-body-14_regular">
          助您夺回交易世界的主动权
        </div>
        <div class="orderflowHeaderBtns flex">
          <a class="primary-default_large" href="{$register}" target="_blank" rel="nofollow">申请开通订单流 <span
              class="iconfont icon-right"></span></a>
          <a class="secondary-default_large" href="https://www.mifipedia.com/files/software/index.zip">下载订单流工具 <span
              class="iconfont icon-right"></span></a>
        </div>
        <div class="orderflowHeaderTips body-14_regular md-footnote-regular_12">
          <span class="tip-text">账户净值大于$50000，即可免费申请</span>
          <a class="tip-link cursor-pointer" target="_blank"
            href="https://support.ebchelp.com/hc/zh-cn/articles/38220463065881-%E8%AE%A2%E5%8D%95%E6%B5%81%E5%88%86%E6%9E%90%E5%B7%A5%E5%85%B7%E5%AE%89%E8%A3%85%E6%8C%87%E5%8D%97">安装指南</a>
        </div>
      </div>
      <img class="orderflowHeaderModel" src="@/assets/image/MiFi/orderFlowHeader.png" alt="" />
    </div>
    <div class="tradeDeepCode">
      <div class="contentBox">
        <div class="tradeDeepCodeCards flex justify-between items-center scroll-fade-up">
          <div class="tradeDeepCodeCard">
            <img class="icon" src="@/assets/image/MiFi/icon_1R.svg" alt="" />
            <div class="subtitle-18_medium md-body-16_medium text-center">
              追踪主力资金
            </div>
          </div>
          <div class="splitLine"></div>
          <div class="tradeDeepCodeCard">
            <img class="icon" src="@/assets/image/MiFi/icon_2R.svg" alt="" />
            <div class="subtitle-18_medium md-body-16_medium text-center">
              构建高胜率分析系统
            </div>
          </div>
          <div class="splitLine"></div>
          <div class="tradeDeepCodeCard">
            <img class="icon" src="@/assets/image/MiFi/icon_3R.svg" alt="" />
            <div class="subtitle-18_medium md-body-16_medium text-center">
              识别震荡和趋势
            </div>
          </div>
        </div>
        <div class="tradeDeepCodeTitle md-title-24_bold title-48_bold text-center scroll-fade-up">
          全球市场交易深度解码
        </div>
        <div class="tradeDeepCodeList flex justify-between">
          <div class="tradeDeepCodeItem scroll-fade-up">
            <img class="item-img" src="@/assets/image/MiFi/section2_1.png" />
            <div class="item-title subtitle-20_medium md-body-16_medium">
              Order Flow订单流工具组
            </div>
            <div class="item-info content-16_regular md-body-14_regular">
              实时显示市场逐笔成交订单情况，图形化展示不同价格水平的成交分布，帮助交易者了解市场流动性和买卖力量。
            </div>
          </div>
          <div class="tradeDeepCodeItem scroll-fade-up">
            <img class="item-img" src="@/assets/image/MiFi/section2_2.png" />
            <div class="item-title subtitle-20_medium md-body-16_medium">
              Volume筹码分析系统
            </div>
            <div class="item-info content-16_regular md-body-14_regular">
              通过逐tick的分析，精准锁定价值区域，定位主力需求轮廊，深度数据展现成交明细，揭示庄家资金动向。
            </div>
          </div>
          <div class="tradeDeepCodeItem scroll-fade-up">
            <img class="item-img" src="@/assets/image/MiFi/section2_3.png" />
            <div class="item-title subtitle-20_medium md-body-16_medium">
              Delta逐差资金流监控
            </div>
            <div class="item-info content-16_regular md-body-14_regular">
              逐笔分析量价数据，快速识别资金强度，基于AI资金因子和量能关系分析价格，直观呈现机构吸筹派发行为。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="globalMPTool">
      <div class="contentBox">
        <div class="title-48_bold md-title-24_bold text-center scroll-fade-up">
          全球最受欢迎交易工具
        </div>
        <div class="subtitle-20_regular md-footnote-regular_12 globalMPToolDesc text-center scroll-fade-up">
          通过追踪市场上的实时买卖订单量，分析大机构交易行为，帮助投资者识别主力资金提高交易胜率，已被高盛、瑞银等华尔街顶级机构采用，成为专业交易者的必备工具。
        </div>
        <div class="globalMPToolTro flex items-center justify-between">
          <div class="info scroll-fade-up">
            <div class="info-item">
              <div class="info-item-value title-32_bold md-subtitle-20_bold">
                40,000+
              </div>
              <div class="info-item-label body-16_regular md-body-14_regular">
                全球专业用户选择
              </div>
            </div>
            <div class="info-item">
              <div class="info-item-value title-32_bold md-subtitle-20_bold">
                0ms
              </div>
              <div class="info-item-label body-16_regular md-body-14_regular">
                CME数据实时响应
              </div>
            </div>
          </div>
          <div class="globalMPToolTroModel scroll-fade-up">
            <img src="@/assets/image/MiFi/globalMPToolBg.png" class="modelBg" alt="" />
            <img class="bgBlockGif" src="@/assets/image/MiFi/section3_bg.gif" alt="" />
          </div>
          <div class="info scroll-fade-up">
            <div class="info-item">
              <div class="info-item-value title-32_bold md-subtitle-20_bold">
                NO.1
              </div>
              <div class="info-item-label body-16_regular md-body-14_regular">
                对冲基金最热门交易工具
              </div>
            </div>
            <div class="info-item">
              <div class="info-item-value title-32_bold md-subtitle-20_bold">
                NO.1
              </div>
              <div class="info-item-label body-16_regular md-body-14_regular">
                《期货》2019最受欢迎交易技术
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="orderTechSupport">
      <div class="contentBox">
        <div class="orderTechSupportTitle title-48_bold md-title-24_bold scroll-fade-up text-center">
          权威机构技术支持
        </div>
        <div class="orderTechList">
          <div class="orderTechListItem flex items-center scroll-fade-up">
            <img class="techListItemImg" src="@/assets/image/MiFi/section4_1.png">
            <div class="listItemInfo">
              <div class="listItemInfoTitle title-24_medium md-body-16_medium">
                数据提供方
              </div>
              <div class="listItemInfoDesc content-16_regular md-body-14_regular">
                芝加哥商品交易所(CME)是全球最多元化的衍生工具市场，每年处理超过30亿份合约，价值约1千兆美元。CME、CBOT、NYMEX和COMEX交易所涵盖全球基准产品，包括利率、股票指数、外汇、能源、农产品、金属等主要资产类别。芝商所还致力于创新，不断引入新的清算场外产品和服务以管理市场风险。
              </div>
            </div>
          </div>
          <div class="orderTechListItem flex items-center scroll-fade-up">
            <img class="techListItemImg" src="@/assets/image/MiFi/section4_3.png">
            <div class="listItemInfo">
              <div class="listItemInfoTitle title-24_medium md-body-16_medium">
                软件提供商
              </div>
              <div class="listItemInfoDesc content-16_regular md-body-14_regular">
                NinjaTrader是华尔街欧美地区顶尖的金融软件平台之一，专注于股票、期货和外汇交易。其第八代新版本在保持传统软件功能的基础上，提供更深度、更可拓展的系统，以开放、专业、丰富和自由的特点著称。
              </div>
            </div>
          </div>
          <div class="orderTechListItem flex items-center scroll-fade-up">
            <img class="techListItemImg" src="@/assets/image/MiFi/section4_2.png">
            <div class="listItemInfo">
              <div class="listItemInfoTitle title-24_medium md-body-16_medium">
                投教合作商
              </div>
              <div class="listItemInfoDesc content-16_regular md-body-14_regular">
                微观市场数据结构研究所(MIFI)拥有近十年的研究经验，其团队在大数据、高频交易和量化交易领域拥有超过二十年的技术沉淀和研发经验。MIFI提供订单流工具的教学支持，致力于推动金融教育和市场数据结构的深入研究。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="userEvaluate">
      <div class="title-48_bold md-title-24_bold scroll-fade-up text-center">
        用户评价
      </div>
      <div class="evaluateList flex items-stretch ">
        <div class="evaluate-item">
          <img src="@/assets/image/MiFi/userEvaCardBg.png" alt="" class="rightBg" />
          <div class="evaluate-score">
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
          </div>
          <div class="evaluate-text content-16_regular md-content-14_regular">
            “长时间以来，我在交易时苦苦挣扎。学习这套订单流工具后，我的获胜率显著提升到75%。运用订单流确认进出场点位时，我信心满满并坚定执行。”
          </div>
          <div class="evaluate-user flex items-center">
            <img src="@/assets/image/MiFi/evaluateItemLogo1.png" class="evaluate-avatar" />
            <div>
              <div class="evaluate-name subtitle-20_bold md-body-16_bold">Jason Li</div>
              <div class="evaluate-job footnote-regular_12">资深外汇交易员</div>
            </div>
          </div>
        </div>
        <div class="evaluate-item">
          <img src="@/assets/image/MiFi/userEvaCardBg.png" alt="" class="rightBg" />
          <div class="evaluate-score">
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
          </div>
          <div class="evaluate-text content-16_regular md-content-14_regular">
            “订单流工具成了我交易的关键利器。它让我直观地观察并分析大机构的吸筹与派发行为，这对于准确把握进出市场时机至关重要。”
          </div>
          <div class="evaluate-user flex items-center">
            <img src="@/assets/image/MiFi/evaluateItemLogo5.png" class="evaluate-avatar" />
            <div>
              <div class="evaluate-name subtitle-20_bold md-body-16_bold">Emily Turner</div>
              <div class="evaluate-job footnote-regular_12">专业交易策略分析师</div>
            </div>
          </div>
        </div>
        <div class="evaluate-item">
          <img src="@/assets/image/MiFi/userEvaCardBg.png" alt="" class="rightBg" />
          <div class="evaluate-score">
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
          </div>
          <div class="evaluate-text content-16_regular md-content-14_regular">
            “订单流、主力足迹和成交量分布等对日内交易者至关重要，它们能揭示市场动态并提供数据支持。我喜欢外汇订单流数据，它使我的交易策略更加精准。”
          </div>
          <div class="evaluate-user flex items-center">
            <img src="@/assets/image/MiFi/evaluateItemLogo2.png" class="evaluate-avatar" />
            <div>
              <div class="evaluate-name subtitle-20_bold md-body-16_bold">David Clark</div>
              <div class="evaluate-job footnote-regular_12">金融市场分析师</div>
            </div>
          </div>
        </div>
        <div class="evaluate-item">
          <img src="@/assets/image/MiFi/userEvaCardBg.png" alt="" class="rightBg" />
          <div class="evaluate-score">
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
          </div>
          <div class="evaluate-text content-16_regular md-content-14_regular">
            “我觉得订单流工具比我之前用过的其他指标更实用，让我直观地看到市场买单和卖单的交易量，针对数据分析调整交易策略，提高准确率。”
          </div>
          <div class="evaluate-user flex items-center">
            <img src="@/assets/image/MiFi/evaluateItemLogo3.png" class="evaluate-avatar" />
            <div>
              <div class="evaluate-name subtitle-20_bold md-body-16_bold">Richard Wu</div>
              <div class="evaluate-job footnote-regular_12">融资顾问</div>
            </div>
          </div>
        </div>
        <div class="evaluate-item">
          <img src="@/assets/image/MiFi/userEvaCardBg.png" alt="" class="rightBg" />
          <div class="evaluate-score">
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
          </div>
          <div class="evaluate-text content-16_regular md-content-14_regular">
            “订单流工具可以说是很强大的，深入学习，你会发现能了解到更多的市场报价的层级，提前预判到大资金的布局挂单，避免被当韭菜割掉。”
          </div>
          <div class="evaluate-user flex items-center">
            <img src="@/assets/image/MiFi/evaluateItemLogo4.png" class="evaluate-avatar" />
            <div>
              <div class="evaluate-name subtitle-20_bold md-body-16_bold">Nathan Young</div>
              <div class="evaluate-job footnote-regular_12">投资组合经理</div>
            </div>
          </div>
        </div>
        <div class="evaluate-item">
          <img src="@/assets/image/MiFi/userEvaCardBg.png" alt="" class="rightBg" />
          <div class="evaluate-score">
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
            <img src="@/assets/image/MiFi/starN.png" alt="" />
          </div>
          <div class="evaluate-text content-16_regular md-content-14_regular">
            “订单流工具的实用性和准确性极高，显著提升了交易决策效率。通过精细的数据分析和实时市场动态，帮助我们精准把握市场趋势和流动性，做出更好的交易决策。”
          </div>
          <div class="evaluate-user flex items-center">
            <img src="@/assets/image/MiFi/evaluateItemLogo6.png" class="evaluate-avatar" />
            <div>
              <div class="evaluate-name subtitle-20_bold md-body-16_bold">Robert Evans</div>
              <div class="evaluate-job footnote-regular_12">风险管理师</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import seamscroll from '../assets/js/seamless.min.js'
export default {
  mixins: [fadeAnimate],
  data() {
    return {
    }
  },
  mounted() {
    this.initPage()
  },
  created() {

  },
  methods: {
    initPage() {
      seamscroll.init({
        dom: document.getElementsByClassName("evaluateList")[0],
        direction: 2,
        step: 0.6,
        hoverStep: 0.3,
        hoverStop: false,
      });
    }
  }
}
</script>

<style scoped>

  .orderflowHeader{
  height: 640rem;
  padding: 0rem 0 0 calc(50vw - 600rem);
  background: var(--ebc-neutral-bg_c);
  display: flex;
  gap: 9rem;
}
.orderflowHeaderMain{
  padding-top: 160rem;
  flex: 0 0 688rem;
}
.orderflowHeaderDesc{
  margin: 24rem 0 64rem;
  color: var(--ebc-text-secondary);
}
.orderflowHeaderBtns{
  gap: 24rem;
  margin: 64rem 0 24rem;
}
.orderflowHeaderBtns a{
  gap: 5rem;
}
.orderflowHeaderBtns a:hover{
  color: var(--ebc-text-primary_white);
}
.orderflowHeaderBtns a:nth-child(2):hover{
  color: var(--ebc-basecolor-active-500);
}
.orderflowHeaderTips {
  color: var(--ebc-text-secondary);
}
.orderflowHeaderTips a{
  margin-left: 8rem;
  color: var(--ebc-basecolor-active-500);
  text-decoration: underline;
}

.orderflowHeaderModel{
  width: 615rem;
  height: 615rem;
}
.contentBox{
  max-width: 1200rem;
  margin-inline: auto;
}

@media (min-width: 996px) {
  .ar .orderflowHeader{
    padding-left: 0;
    padding-right: calc(50vw - 600rem);
  }
}

@media (max-width: 996px) {
  .contentBox{
    max-width: 100%;
    padding-inline: 32rem;
  }
.orderflowHeader{
  height: auto;
  padding: 0 32rem 80rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
}
.orderflowHeaderModel{
  width: 520rem;
  height: 520rem;
}
.orderflowHeaderDesc{
  margin: 16rem 0 64rem;
}
.orderflowHeaderMain{
  width: 100%;
  flex: 1;
  order: 2;
  padding-top: 0;
  text-align: center;
}
.orderflowHeaderBtns{
  flex-direction: column;
  gap: 32rem;
  margin-bottom: 48rem;
}
.orderflowHeaderBtns a{
  width: 100%;
}
}


.tradeDeepCode{
  padding:240rem 0 120rem;
  position: relative;
}
.tradeDeepCode .tradeDeepCodeCards{
  position: absolute;
  top: 0rem;
  width: 1200rem;
  border-radius: var(--ebc-corner-radius-rc16);
  border: 1px solid #FFF;
  background: linear-gradient(250deg, rgba(255, 255, 255, 0.80) 36.88%, #FFF 100%);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  padding: 32rem;
}
@media (min-width: 996px) {
.tradeDeepCode .tradeDeepCodeCards{
transform: translateY(-50%)!important;
}
}
.tradeDeepCode .tradeDeepCodeCards .splitLine{
  width: 1px;
  height: 64px;
  background: var(--ebc-neutral-divider_regular);
  margin-inline: 32rem;
}
.tradeDeepCode .tradeDeepCodeCards .tradeDeepCodeCard{
  flex: 1;
  text-align: center;
}
.tradeDeepCode .tradeDeepCodeCards .tradeDeepCodeCard img{
  width: 64rem;
  height: 64rem;
  margin-bottom: 16rem;
}
.tradeDeepCodeList{
  gap: 24rem;
  margin-top: 60rem;
}

.tradeDeepCodeItem .item-img{
  width: 384rem;
  height: 240rem;
}

.tradeDeepCodeItem .item-title{
  margin:24rem 0 8rem;
}

.tradeDeepCodeItem .item-info{
  color: var(--ebc-text-secondary);
}

@media (max-width: 996px) {
  .tradeDeepCode{
    padding: 80rem 0 160rem;
  }
  .tradeDeepCodeCards .splitLine{
    display: none;
  }

  .tradeDeepCode  .tradeDeepCodeCards{
    padding: 0;
    position: relative;
    top:0;
    gap:32rem;
    flex-direction: column;
    width: 100%;
    background-color: transparent;
    box-shadow: unset;
    backdrop-filter: unset;
  }
  .tradeDeepCodeCards .tradeDeepCodeCard{
    width: 100%;
    border-radius: var(--ebc-corner-radius-rc16);
    background: var(--ebc-neutral-bg_b);
    padding:32rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 32rem;
  }
  .tradeDeepCodeCards .tradeDeepCodeCard img{
    margin-bottom: 0!important;
  }
  .tradeDeepCodeTitle{
    margin: 160rem 0 80rem;
  }
  .tradeDeepCodeList {
    flex-direction: column;
    gap: 42rem;
  }
  .tradeDeepCodeItem .item-img{
    width: 100%;
    height: auto;
  }
  .tradeDeepCodeItem .item-title{
    margin: 32rem 0 16rem;
  }
  .tradeDeepCodeItem  div{
    padding-inline: 16rem;
  }
}


.globalMPTool{
  background:#f7f7f7;
  padding: 120rem 0;
}

.globalMPToolDesc{
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}

.globalMPToolTro{
  gap: 24rem;
}

.globalMPToolTro .info{
  flex: 0 0 282rem;
}

.globalMPToolTro .info .info-item{
  padding: 16rem 24rem;
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_a);
}
.globalMPToolTro .info .info-item:nth-child(2){
  margin-top: 32rem;
}
.globalMPToolTro .info .info-item .info-item-label{
  margin-top: 16rem;
  color: var(--ebc-text-secondary);
}
.globalMPToolTroModel{
  position: relative;
}
.globalMPToolTroModel .modelBg{
  position: relative;
  z-index: 2;
}

.globalMPToolTroModel .bgBlockGif{
  position: absolute;
  left: 50rem;
  top: 10rem;
    width: 482rem;
    height: 310rem;
}

@media (max-width: 996px) {
  .globalMPTool{
    padding: 160rem 0;
  }
  .globalMPToolDesc{
    margin-bottom: 80rem;
  }
  .globalMPToolTro{
    flex-direction: column;
    gap:0;
  }
  .globalMPToolTro .globalMPToolTroModel{
    margin-bottom: 80rem;
  }
  .globalMPToolTro .info{
    order: 2;
  }
  .globalMPToolTroModel .bgBlockGif{
      left: 60rem;
      top: 10rem;
      width: 559rem;
      height: 358rem;
  }
  .globalMPToolTro .info{
    flex: 1;
    width: 100%;
  }
  .globalMPToolTro .info:nth-child(1){
    margin-bottom: 32rem;
  }
  .globalMPToolTro .info .info-item{
    padding:16rem 32rem;
  }
}


.orderTechSupport{
  padding: 120rem 0;
}

.orderTechList{
  margin-top: 60rem;
}

.orderTechList .orderTechListItem{
  padding: 24rem;
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  gap: 24rem;
}

.orderTechList .orderTechListItem:nth-child(n+2){
  margin-top: 16rem;
}

.orderTechListItem .techListItemImg{
    width: 340rem;
    height: 176.8rem;
    border-radius: var(--ebc-corner-radius-rc08);
    box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.04);
}

.orderTechListItem .listItemInfo .listItemInfoDesc{
  margin-top: 16rem;
  color: var(--ebc-text-secondary);
}

@media (max-width: 996px) {
  .orderTechSupport{
    padding: 160rem 0;
  }
  .orderTechList .orderTechListItem{
    flex-direction: column;
    gap: 48rem;
    padding: 32rem;
  }
  .orderTechListItem .techListItemImg{
    width: 100%;
    height: auto;
  }
 
  .orderTechList .orderTechListItem:nth-child(n+2){
    margin-top: 32rem;
  }
}

.userEvaluate{
  overflow: hidden;
  padding-bottom: 120rem;
}
.evaluateList{
  margin-top: 40rem;
  padding-top: 20rem;
}
.evaluate-item{
  position: relative;
  flex: 0 0 384rem;
  min-height: 320rem;
  padding: 32rem 24rem;
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  margin-inline: 16rem;
  display: flex;
  flex-direction: column;
  transition: transform  0.5s ease-in-out,background 0.5s ease-in-out;
}
.evaluate-item:hover{
  transform: translateY(-16rem);
  border-radius: var(--Corner-Radius-RC16, 16px);
  border: 0.5px solid var(--ebc-brand-secondary-gold);
  background: var(--ebc-neutral-beige);
  z-index: 2;
}
.evaluate-item .evaluate-text{
  margin: 24rem 0 auto;

}
.evaluate-item .rightBg{
  position: absolute;
  width: 60rem;
  height: 48rem;
  right: 24rem;
  top: 24rem;
}

.evaluate-score img{
  width: 18rem;
  height: 18rem;
  margin: 3rem;
}
.evaluate-user{
  gap: 16rem;
  margin-top: 10rem;
}
.evaluate-user img{
  width: 48rem;
  height: 48rem;
  border-radius: 50%;
}
.evaluate-user .evaluate-job{
  margin-top: 2rem;
  color: var(--ebc-text-secondary);
}

@media (max-width: 996px) {
.evaluate-item{
  flex:0 0 686rem; 
  min-height:480rem;
  padding: 32rem;
  border-radius: 16px;
  margin-inline: 24rem;
}
.evaluate-score img{
  width: 24rem;
  height: 24rem;
  margin: 4rem;
}
}
</style>
